import axios from 'axios';
import Cookies from 'js-cookie';
import Base_URL from '../config/apiConfig';

const backendAPI = axios.create({
  baseURL: Base_URL,
  withCredentials: false,   // No need when using headers
});

// Attach token to every request
backendAPI.interceptors.request.use(config => {
  const token = Cookies.get('authToken');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

export default backendAPI;
